import type { ScrollTweenFunction } from '../types';
import { gsap } from 'gsap';

/**
 * ScrollContinuous Animation Logic - Simulates a single long page scroll.
 */
export const scrollContinuous: ScrollTweenFunction = ({
    target, scrollTimeline, direction, top, pageIndex, numberOfPages, duration, insertTweenAt, containersToTap
}) => {
    if (!scrollTimeline || typeof pageIndex === 'undefined' || typeof numberOfPages === 'undefined' || typeof duration === 'undefined' || typeof insertTweenAt === 'undefined') return;
    duration = 5
    if (direction === "forward" || direction === "init") {
        if (top) {
            // Current page scrolling up and out
            if (pageIndex < numberOfPages) {
                gsap.set(target, { autoAlpha: 1 }); // Ensure visible before animating
                const tween = gsap.to(target, { y: "-100%", ease: "none", duration });
                scrollTimeline.add(tween, insertTweenAt);
            }
        } else {
            // Next page scrolling up from below
            gsap.set(target, { y: "100%", autoAlpha: 1 }); // Start directly below the current page
            const tween = gsap.to(target, { y: "0%", ease: "none", duration });
            scrollTimeline.add(tween, "<"); // Add simultaneously with the top element's animation
        }
    }

    if (direction === "back") {
        const backDuration = containersToTap ? 50 : 100;
        const backInsertTweenAt = containersToTap ? 50 : 0;
        if (top) {
            // Previous page scrolling back down into view from above
            gsap.set(target, { autoAlpha: 1 }); // Start above
            const tween = gsap.to(target, { y: "-100%", ease: "none", duration: backDuration });
            scrollTimeline.add(tween, backInsertTweenAt);
        } else {
            // Current page scrolling back down and out of view
            gsap.set(target, { y: "100%", autoAlpha: 1 }); // Ensure visible before animating
            const tween = gsap.to(target, { y: 0, ease: "none", duration: backDuration });
            scrollTimeline.add(tween, "<"); // Add simultaneously
        }
    }
};
